import apiClient from './client'

/**
 * 优惠券相关 API
 */
export const couponApi = {
  /**
   * 获取用户优惠券列表
   * @param {number} [status] - 优惠券状态 (可选)
   * @returns {Promise} 优惠券列表响应
   */
  getUserCouponList(status) {
    const params = {}
    if (status !== undefined && status !== null) {
      params.status = status
    }
    return apiClient.get('/coupons/get-user-coupon-list', { params })
  }
}
